export const aiProductDescriptionMediaLimit = 1;
